import React from 'react';
import { I18n } from 'react-redux-i18n';

import CurrencyHelper from '../../../helpers/currencyHelper';
import { selectCanSeeGiftAid } from '../../../helpers/giftAidHelper';
import { useAppSelector } from '../../../hooks/redux/useApp';

import styles from './RaisedTotal.module.css';

export const RAISED_TOTAL_I18N_KEY = 'components.raised-total';

export interface RaisedTotalEntity {
  raisedAmount?: number | null;
  giftAidAmount?: number | null;
  currency?: string | null;
  organization?: { currency?: string | null } | null;
}

interface RaisedTotalProps {
  entity: RaisedTotalEntity;
}

// Gift Aid sits beside the raised amount and is not part of it, so it is shown
// as a separate figure rather than added in. Only confirmed Gift Aid reaches
// giftAidAmount, and the line only appears where Gift Aid applies (UK).
export const RaisedTotal = ({ entity }: RaisedTotalProps) => {
  const canSeeGiftAid = useAppSelector(selectCanSeeGiftAid);
  if (!canSeeGiftAid) return null;

  const currency =
    entity.currency || entity.organization?.currency || undefined;
  const raised = CurrencyHelper.formatCurrency(
    entity.raisedAmount ?? 0,
    currency
  );
  const giftAidAmount = entity.giftAidAmount ?? 0;

  const text =
    giftAidAmount > 0
      ? I18n.t(`${RAISED_TOTAL_I18N_KEY}.raised-with-gift-aid`, {
          raised,
          giftAid: CurrencyHelper.formatCurrency(giftAidAmount, currency)
        })
      : I18n.t(`${RAISED_TOTAL_I18N_KEY}.raised`, { raised });

  return <p className={styles.raisedTotal}>{text}</p>;
};
